import { createGlobalStyle } from 'styled-components'
import normalize from 'normalize.css'

import MEDIA from './media'
import theme from './theme'
import Inter from './fonts/Inter'
import AbihomeIconsStyles from './fonts/AbihomeIcons/style.css'

const GlobalStyle = createGlobalStyle`
  /* Injecting normalize.css */
  ${normalize};
  
  /* Adding fonts */
  ${Inter};
  
  /* Icon font */
  ${AbihomeIconsStyles};

  /* Common & global styles */
  * {
    box-sizing: border-box;
  }
  
  ${MEDIA.mobile} {
    html {
      position: relative;
      min-height: 100%;
    }
  }
  
  body,
  input,
  textarea,
  select,
  button {
    font-family: Inter, sans-serif;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${theme.primary};
    
    &:focus {
      outline: none;
    }
  } 
  
  body {
    font-size: 14px;
    background: ${theme.bg};
  }
  
  a {
    color: ${theme.primary};
    text-decoration: none;
  }
  
  button {
    cursor: pointer;
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`

export default GlobalStyle



// WEBPACK FOOTER //
// ./src/styles/global.js